// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".p-btn{text-transform:none!important;color:#fff!important}.btn-wrapper{margin:1em .5em}.v-btn__content{font-weight:600}.p-btn:hover{background-color:var(--grey__dark)!important}", ""]);
// Exports
module.exports = exports;
